import ProgramRequestDetail from './ProgramRequestDetail';

export default ProgramRequestDetail;
